

export class Client {
    Code!: string;
    Name!: string;
    IncId!: number;
    SqlId!: number;
    IsDefault!: boolean;
    City!: string;

    static mapFromJSON(json: any) {
        const m = new Client();

        m.Code = json['code'];
        m.Name = json['name'];
        m.IncId = json['incId'];
        m.SqlId = json['sqlId'];
        m.IsDefault = json['isDefault'];
        m.City = json['city'];

        return m;
    }
}
